import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { appRoutes } from './app.routes';
import { withCredentialsInterceptor } from './app/interceptors/with-credentials.interceptor';
import { csrfInterceptor } from './app/interceptors/csrf.interceptor';
import { authRefreshInterceptor } from './app/interceptors/auth-refresh.interceptor';
import { AuthStateService } from './app/services/auth-state.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([withCredentialsInterceptor, csrfInterceptor, authRefreshInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        // Kicks off the session-cookie check as early as possible. This does NOT reliably
        // block the router's initial navigation (confirmed: guards can run before this
        // resolves), so AuthGuard/HomeRedirectGuard also await ensureInitialized()
        // themselves via the shared, deduplicated observable on AuthStateService.
        provideAppInitializer(() => firstValueFrom(inject(AuthStateService).ensureInitialized())),
        MessageService
    ]
};
